import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/lib/auth";
import Layout from "@/components/Layout";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import CommandCentre from "@/pages/CommandCentre";
import Ideas from "@/pages/Ideas";
import ScriptStudio from "@/pages/ScriptStudio";
import MonthlyPlan from "@/pages/MonthlyPlan";
import CalendarView from "@/pages/CalendarView";
import InsightsImport from "@/pages/InsightsImport";
import Analytics from "@/pages/Analytics";
import Competitors from "@/pages/Competitors";
import Trends from "@/pages/Trends";
import KnowledgeBase from "@/pages/KnowledgeBase";
import Approvals from "@/pages/Approvals";
import Settings from "@/pages/Settings";
import Experiments from "@/pages/Experiments";
import ShootPlanner from "@/pages/ShootPlanner";
import "@/App.css";

function Protected({ children }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="p-8">Loading…</div>;
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

function AppRoutes() {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/register" element={<Register />} />
      <Route element={<Protected><Layout /></Protected>}>
        <Route path="/" element={<CommandCentre />} />
        <Route path="/monthly-plan" element={<MonthlyPlan />} />
        <Route path="/calendar" element={<CalendarView />} />
        <Route path="/ideas" element={<Ideas />} />
        <Route path="/scripts" element={<ScriptStudio />} />
        <Route path="/scripts/:id" element={<ScriptStudio />} />
        <Route path="/shots" element={<ShootPlanner />} />
        <Route path="/competitors" element={<Competitors />} />
        <Route path="/trends" element={<Trends />} />
        <Route path="/analytics" element={<Analytics />} />
        <Route path="/experiments" element={<Experiments />} />
        <Route path="/knowledge" element={<KnowledgeBase />} />
        <Route path="/approvals" element={<Approvals />} />
        <Route path="/import" element={<InsightsImport />} />
        <Route path="/settings" element={<Settings />} />
      </Route>
    </Routes>
  );
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Toaster position="top-right" richColors />
        <AppRoutes />
      </BrowserRouter>
    </AuthProvider>
  );
}
